module.exports = __webpack_public_path__ + "img/bgtop.6da3f069.jpg";